import { createContext } from "react";

const UserContext = createContext({
  myName: "Default",
});



export default UserContext;
